import React from "react";
import { FaIcon } from "lib/FaIcon";
import { Truncate } from "lib/Truncate";
import { Pill } from "./Pill";
import { removeParam, push } from "../api/filterUrlMaker";
import { ClearAllPillsButton, AddFilterButton, MyFiltersButton } from "./AddClearFilterButtons";
import { formatPillDate, isDateCategory } from "./formatPillDate";
import { ButtonToolbar } from "react-bootstrap";
import { _t } from "app/i18n/i18n";

const PillsBar = ({ filter }) => {
  const pills = Object.entries(filter)
    .map(([category, options]) => options.map((option) => ({ category, text: option })))
    .flat()
    .filter((pill) => !isExcluded(pill.category))
    .filter((pill) => pill.text); //remove textless pills

  return (
    <ButtonToolbar className="pb-1 align-items-center">
      <Truncate show={10} more={10}>
        {pills.map(({ text, category }, key) => {
          if (isDateCategory(category)) text = formatPillDate(text, category);
          const label = category === "title" ? `${text} (${_t("Report titles only")})` : text;
          return (
            <Pill
              key={key + text}
              text={
                <>
                  {label} <X />
                </>
              }
              isActive={true}
              variant={variantByCategory[category] || "secondary"}
              onClick={() => push(removeParam(category, text))}
              className="p-2 mb-1"
            />
          );
        })}
      </Truncate>

      <ButtonToolbar className="ml-auto">
        <AddFilterButton />
        <ClearAllPillsButton />
        <MyFiltersButton />
      </ButtonToolbar>
    </ButtonToolbar>
  );
};

// TODO: removing pill clears keyword search

export const isExcluded = (category) =>
  ["sort", "SortAsc", "SortDesc", "From", "Language", "includeSynopsis"].includes(category);

export const X = () => <FaIcon icon="fa fa-times ml-1" align="" />;

// colours tags by category
export const variantByCategory = {
  "Asset Class": "info",
  Regions: "primary",
  Company: "success",
  CompanyWithTicker: "success",
  "Asset Class-JA": "info",
  "Regions-JA": "primary",
  "Company-JA": "success",
  "CompanyWithTicker-JA": "success",
};

export default PillsBar;
